// src/App.tsx
import { NoticeProvider } from "./contexts/NoticeContext";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "./contexts/UserContext";
import Layout from "./components/Layout";
import NoticePopup from "./components/NoticePopup";

// 기본 페이지
import MainPage from "./pages/MainPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordRequest from "./pages/ResetPasswordRequest";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SignupPage from "./pages/SignupPage";
import SignupNickname from "./pages/SignupNickname";
import MyPage from "./pages/MyPage";

// 게시판 관련
import BoardPage from "./pages/BoardPage";
import BoardDetailPage from "./pages/BoardDetailPage";
import BoardWritePageWrapper from "./pages/BoardWritePageWrapper";

// 익명게시판
import AnonymousBoardPage from "./pages/AnonymousBoardPage";

// 기타 페이지
import AboutPage from "./pages/AboutPage";
import NoticePage from "./pages/NoticePage";
import { AgeConfirmTerms } from "./pages/terms/AgeConfirmTerms";
import { ServiceTerms } from "./pages/terms/ServiceTerms";
import { PrivacyTerms } from "./pages/terms/PrivacyTerms";

// 새롭게 추가된 메뉴 페이지 (Coming soon)
import OpportunitiesPage from "./pages/OpportunitiesPage";
import OpportunityNewPage from "./pages/OpportunityNewPage";
import OpportunityDetailPage from "./pages/OpportunityDetailPage";
import OpportunityEditPage from "./pages/OpportunityEditPage";
import ArtistsPage from "./pages/ArtistsPage";
import ArtLuckPage from "./pages/ArtLuckPage";

function ProtectNickname({ children }: { children: React.ReactNode }) {
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user && !user.nickname && location.pathname !== "/additional-info") {
      navigate("/additional-info", { replace: true });
    }
    if (!user && location.pathname === "/additional-info") {
      navigate("/login", { replace: true });
    }
  }, [user, location, navigate]);

  return <>{children}</>;
}

export default function App() {
  return (
    <NoticeProvider>
      <NoticePopup />

      <Layout>
        <ProtectNickname>
          <Routes>

            {/* 기본 */}
            <Route path="/" element={<MainPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password-request" element={<ResetPasswordRequest />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/signup/*" element={<SignupPage />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/additional-info" element={<SignupNickname />} />

            {/* Free Talk */}
            <Route path="/board" element={<BoardPage />} />
            <Route path="/board/:id" element={<BoardDetailPage />} />
            <Route path="/write" element={<BoardWritePageWrapper />} />

            

            {/* Secret/Anon Talk (익명게시판) */}
            <Route path="/anonymous" element={<AnonymousBoardPage />} />

            {/* 새 메뉴: Opportunities / Artists / Art-Luck */}
            <Route path="/opportunities" element={<OpportunitiesPage />} />
            <Route path="/opportunities/new" element={<OpportunityNewPage />} />
            

            <Route path="/artists" element={<ArtistsPage />} />
            <Route path="/artluck" element={<ArtLuckPage />} />

            {/* 기타 */}
            <Route path="/terms/AgeConfirmTerms" element={<AgeConfirmTerms />} />
            <Route path="/terms/ServiceTerms" element={<ServiceTerms />} />
            <Route path="/terms/PrivacyTerms" element={<PrivacyTerms />} />
            <Route path="/opportunities/:id" element={<OpportunityDetailPage />} />
            <Route path="/opportunities/edit/:id" element={<OpportunityEditPage />} />

            <Route path="/about" element={<AboutPage />} />
            <Route path="/notice" element={<NoticePage />} />

          </Routes>
        </ProtectNickname>
      </Layout>
    </NoticeProvider>
  );
}
